function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.208 6.87L.12 1.48A.444.444 0 010 1.17.467.467 0 01.121.857l.68-.728A.412.412 0 011.095 0a.39.39 0 01.292.13L5.5 4.48 9.614.13A.412.412 0 019.906 0a.39.39 0 01.292.13l.68.726a.444.444 0 01.122.312.467.467 0 01-.121.312L5.792 6.87A.412.412 0 015.5 7a.39.39 0 01-.292-.13z",
  fill: "#848F99"
});

function SvgChevronDownSmaller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "none"
  }, props), _ref);
}

export default SvgChevronDownSmaller;